import { createTheme } from '@mui/material/styles';
import { JBTheme } from '@bjb-gcrm/gcrm-frontend-components';
import { palette } from './palette';
import { overrides } from './overrides';

export const theme = createTheme({
  palette,
  typography: JBTheme.typography,
  components: overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});
